// extracted by mini-css-extract-plugin
module.exports = {"Container":"src-hocs-withSideModalPending-styles__Container--cLywn","LoaderWrapper":"src-hocs-withSideModalPending-styles__LoaderWrapper--2BVtK"};